import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 生成驗證Token資料
 */
export interface IGenerateTokenData {
    /** 原始Token (用於QR Code或URL) - 80字元的HEX編碼Token */
    token: string;
    /** Token的SHA-256雜湊值 (64字元) - 此值已儲存於資料庫 */
    tokenHash: string;
    /** Token到期時間 */
    expiry: string;
    /** 手機端驗證用的完整URL */
    mobileVerifyUrl: string;
    /** QR Code 資料 (Base64編碼的PNG圖片，可直接用於前端顯示) */
    qrCodeBase64: string | null;
}

/**
 * 生成驗證Token回應
 */
export interface IGenerateTokenResponse {
    /** 回應狀態 */
    status: boolean;
    /** 錯誤代碼 */
    code: number;
    /** 例外訊息 */
    exception: string | null;
    /** 訊息 */
    message: string | null;
    /** Token資料 */
    result: IGenerateTokenData | null;
}

/**
 * Token - 生成一次性驗證Token API
 *
 * @description 生成一次性驗證Token，用於手機端掃描QR Code驗證
 * @returns Promise<IGenerateTokenResponse>
 */
export async function GenerateToken(): Promise<IGenerateTokenResponse> {
    const url = RouteUrlList.API_GenerateToken.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return await ApiClient.post(url, {}, config).then((res: AxiosResponse<IGenerateTokenResponse>) => {
        return res.data;
    });
}

export default GenerateToken;
